<template>
  <!-- <v-divider class="mt-n2 mx-0"></v-divider> -->
  <div>
    <v-card class="mt-5 ma-1">
      <v-data-table :headers="headers" dense :items="InvoiceApp">
        <template v-slot:[`item.Name`]="{ item }">
          <span class="caption">{{ item.Name }}</span>
        </template>
        <template v-slot:[`item.mobile_no`]="{ item }">
          <span class="caption">{{ item.mobile_no }}</span>
        </template>
        <template v-slot:[`item.RefNo`]="{ item }">
          <span class="caption">{{ item.RefNo }}</span>
        </template>
        <template v-slot:[`item.date_of_txn`]="{ item }">
          <span class="caption">{{ item.date_of_txn }}</span>
        </template>
        <template v-slot:[`item.initiated_by`]="{ item }">
          <span class="subtitle-2">{{ item.initiated_by }}</span>
          <br />
          <span class="caption">{{ item.initiated_on }}</span>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <div v-if="item.status == 'Pending for approval'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="caption orange--text font-weight-medium"
                  >PENDING</span
                >
              </template>
              <span>PENDING FOR APPROVAL</span>
            </v-tooltip>
          </div>
          <div v-if="item.status == 'Approved'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="caption green--text font-weight-medium"
                  >APPROVED</span
                >
              </template>
              <span>APPROVED</span>
            </v-tooltip>
          </div>
          <div v-if="item.status == 'Rejected'">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <span v-on="on" class="caption red--text font-weight-medium"
                  >REJECTED</span
                >
              </template>
              <span>REJECTED</span>
            </v-tooltip>
          </div>
        </template>
        <template v-slot:[`item.approved_on`]="{ item }">
          <span class="subtitle-2">{{ item.approved_by }}</span>
          <br />
          <span class="caption">{{ item.approved_on }}</span>
        </template>
        <template v-slot:[`item.amount`]="{ item }">
          <span class="caption">{{ item.amount }}</span>
        </template>
        <template v-slot:top>
          <v-layout row wrap class="mb-7">
            <v-row class="ml-2">
              <v-spacer></v-spacer>
              <v-col lg="4" class="mt-2 mr-5">
                <v-text-field
                  v-model="searchText"
                  shaped
                  outlined
                  dense
                  class="mt-2"
                  color="primary"
                  append-icon="mdi-magnify"
                  label="Search"
                  hide-details
                ></v-text-field>
              </v-col>
            </v-row>
          </v-layout>
        </template>
      </v-data-table>
    </v-card>
    <OverleyProccessg :overlay="overlay" />
  </div>
</template>

<script>
import OverleyProccessg from "@/Views/OverleyProccessg.vue";
// import moment from "moment";
// import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    OverleyProccessg,
  },
  data: () => ({
    searchHint: "",
    overlay: false,
    loadingSubmit: false,
    rules: {
      amount: [(v) => !!v || "Required"],
    },
    InvoiceApp: [
      {
        Name: "Jetha Laal",
        mobile_no: "7686659007",
        amount: 40,
        RefNo: "RefNo32424e",
        NatureOfPayment: "Ragular",
        created_on: "20-01-2020",
      },
      {
        Name: "Devika Negi",
        mobile_no: "7686650000",
        RefNo: "RefNo45365",
        amount: 40,
        NatureOfPayment: "One Time",
        created_on: "20-01-2020",
      },
    ],
    comments: "",
    chequenumber: "",
    modal: false,
    date_of_transaction: new Date().toISOString().substr(0, 10),
    amount: "",
    banknamedetails: "",
    paymentMode: "CHEQUE",
    chequenumberCHEQUE: "",
    chequenumberBANK: "",
    paymentModeList: ["CHEQUE", "BANK TRANSFER"],
    RequestFunds: false,
    headers: [
      {
        text: "Vendor Name",
        value: "Name",
      },
      {
        text: "Payment Mode",
        value: "mobile_no",
      },
      {
        text: "#Ref No.",
        value: "RefNo",
      },
      {
        text: "Date of Transaction",
        value: "created_on",
      },
      {
        text: "Amount",
        value: "amount",
      },
      {
        text: "Approved By/On",
        value: "approved_on",
      },
    ],

    listOfBankDetails: [],
    fundListBank: [],
    searchText: "",
  }),
  created() {},

  methods: {},
};
</script>

<style>
</style>